<template>
  <div>
    <div
      v-if="contextMenu.visible"
      :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }"
      class="context-menu"
      @click.stop
    >
      <ul>
        <li @click="copyText" v-if="contextMenu.hasSelection">
          <i class="fa fa-copy mr-2"></i>Copy
        </li>
        <li @click="cutText" v-if="contextMenu.hasSelection">
          <i class="fa fa-scissors mr-2"></i>Cut
        </li>
        <li @click="pasteText"><i class="fa fa-paste mr-2"></i>Paste</li>

        <li
          @click="
            editor.chain().focus().removeComment().run();
            $emit('hide');
          "
          v-if="contextMenu.hasComment"
        >
          <i class="fa-solid fa-comment-slash mr-2"></i>Remove comment
        </li>
        <li @click="addDocumentComment" v-else-if="contextMenu.hasSelection">
          <i class="fa-solid fa-comment mr-2"></i>Add comment
        </li>

        <li @click="splitDocument" v-if="!contextMenu.hasSelection">
          <i class="fa fa-file-circle-plus mr-2"></i>Split into new document
        </li>
        <li @click="mergeDocument" v-if="!contextMenu.hasSelection && contextMenu.canMerge">
          <i class="fa fa-compress mr-2"></i>Merge with previous document
        </li>
        <li @click="addPlaceholder" v-if="!contextMenu.hasSelection">
          Add placeholder
        </li>
        <li @click="addCondition" v-if="contextMenu.hasSelection">
          Wrap with condition
        </li>
        <li @click="addLoop" v-if="contextMenu.hasSelection">Wrap with loop</li>
        <li
          @click="() => extendCondition('conjunction')"
          v-if="
            contextMenu.isConditionSelected &&
            (!contextMenu.conditionSelectionOptions.modifier ||
              contextMenu.conditionSelectionOptions.modifier === 'or')
          "
        >
          <!-- <span class="font-monospace small font-bold">AND</span>  -->
          Add conjunction
        </li>
        <li
          @click="() => extendCondition('disjunction')"
          v-if="
            contextMenu.isConditionSelected &&
            (!contextMenu.conditionSelectionOptions.modifier ||
              contextMenu.conditionSelectionOptions.modifier === 'and')
          "
        >
          <!-- <span class="font-monospace small font-bold">OR</span>  -->
          Add disjunction
        </li>
        <li
          @click="aiGenerate"
          v-if="
            !contextMenu.hasSelection &&
            this.$store.getters.isIntegrationActive('protokol-clerk')
          "
        >
          <i class="fa-solid fa-wand-magic-sparkles"></i>
          Generate text
        </li>
        <li
          @click="aiFixGrammar"
          v-if="
            contextMenu.hasSelection &&
            this.$store.getters.isIntegrationActive('protokol-clerk')
          "
        >
          <i class="fa-solid fa-wand-magic-sparkles"></i>
          Fix grammar
        </li>
        <li
          @click="aiTranslate"
          v-if="
            contextMenu.hasSelection &&
            this.$store.getters.isIntegrationActive('protokol-clerk')
          "
        >
          <i class="fa-solid fa-language"></i>
          Translate
        </li>
      </ul>
    </div>

    <main-dialog
      ref="placeholderPromptModal"
      title="Enter placeholder Key"
      @ok="addPlaceholderConfirm"
      @cancel="$refs.placeholderPromptModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Add"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="placeholderPromptInput"
          placeholder="Type placeholder key"
        ></b-form-input>
      </div>
    </main-dialog>
    <!-- <b-button @click="addPlaceholder()" variant="light">
      Add placeholder
    </b-button> -->

    <main-dialog
      ref="conditionPromptModal"
      title="Enter the condition variable"
      @ok="addConditionConfirm"
      @cancel="$refs.conditionPromptModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Add"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="conditionPromptInput"
          placeholder="Type the condition variable"
        ></b-form-input>
      </div>
    </main-dialog>
    <!-- <b-button @click="addCondition()" variant="light"> Add condition </b-button> -->

    <main-dialog
      ref="loopPromptModal"
      title="Enter the variable to loop over"
      @ok="addLoopConfirm"
      @cancel="$refs.loopPromptModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Add"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="loopPromptInput"
          placeholder="Type the variable to loop over"
        ></b-form-input>
      </div>
    </main-dialog>
    <!-- <b-button @click="addLoop()" variant="light"> Add loop </b-button> -->

    <main-dialog
      ref="extendConditionPromptModal"
      title="Enter the condition variable"
      @ok="extendConditionConfirm"
      @cancel="$refs.extendConditionPromptModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Add"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="extendConditionPromptInput"
          placeholder="Type the condition variable"
        ></b-form-input>
      </div>
    </main-dialog>

    <main-dialog
      ref="aiTranslateModal"
      title="Enter the language to translate to"
      @ok="aiTranslateConfirm"
      @cancel="$refs.aiTranslateModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Translate"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="aiTranslateInput"
          placeholder="Language"
        ></b-form-input>
      </div>
    </main-dialog>

    <main-dialog
      ref="aiGenerateModal"
      title="What would you like to generate?"
      @ok="aiGenerateConfirm"
      @cancel="$refs.aiGenerateModal.hide()"
      cancel-title="Cancel"
      cancel-variant="danger"
      ok-title="Generate"
      ok-variant="primary"
    >
      <div>
        <b-form-input
          v-model="aiGenerateInput"
          placeholder="What would you like to generate?"
        ></b-form-input>
      </div>
    </main-dialog>
  </div>
</template>

<script>
export default {
  name: "NewDocumentModal",
  props: {
    contextMenu: {
      type: Object,
      required: true,
    },
    editor: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      placeholderPromptInput: "",
      conditionPromptInput: "",
      extendConditionPromptInput: "",
      extendConditionType: null,
      loopPromptInput: "",
      aiGenerateInput: "",
      aiTranslateInput: "",
    };
  },
  methods: {
    copyText() {
      const { state } = this.editor;
      const { from, to } = state.selection;
      const selectedText = state.doc.textBetween(from, to, " ");
      navigator.clipboard.writeText(selectedText);
      this.$emit("hide");
    },
    cutText() {
      const { state, commands } = this.editor;
      const { from, to } = state.selection;
      const selectedText = state.doc.textBetween(from, to, " ");
      if (selectedText) {
        navigator.clipboard.writeText(selectedText);
        commands.deleteSelection();
      }
      this.$emit("hide");
    },
    async pasteText() {
      const { state, commands } = this.editor;
      const { from } = state.selection;
      try {
        const clipboardText = await navigator.clipboard.readText();
        if (clipboardText) {
          commands.insertContentAt(from, clipboardText);
        }
      } catch (error) {
        log.error("Failed to paste text: ", error);
      }

      this.$emit("hide");
    },
    addPlaceholder() {
      this.placeholderPromptInput = "";
      this.$emit("hide");
      this.$refs.placeholderPromptModal.show();
    },
    addPlaceholderConfirm() {
      if (this.placeholderPromptInput.trim() !== "") {
        this.editor.commands.insertContent(
          `{{ .${this.placeholderPromptInput.trim()} }}`
        );
        this.$refs.placeholderPromptModal.hide();
      } else {
        this.$mainDialog.msgBoxOk(this.$t("fieldsNotValid"));
      }
    },

    removeCodeWrapper(text) {
      return text.replace(/^```[a-z]*\n([\s\S]*?)\n```$/i, "$1");
    },
    aiGenerate() {
      this.aiGenerateInput = "";
      this.$emit("hide");
      this.$refs.aiGenerateModal.show();
    },
    async aiGenerateConfirm() {
      if (!this.$store.getters.isIntegrationActive("protokol-clerk")) return;
      if (!this.aiGenerateInput.trim()) {
        this.$mainDialog.msgBoxOk(this.$t("fieldsNotValid"));
        return;
      }

      this.$refs.aiGenerateModal.hide();

      const spinnerId = `ai-spinner-${Math.random().toString(36).slice(2, 9)}`;

      this.editor
        .chain()
        .focus()
        .insertContent({
          type: "spinner",
          attrs: { id: spinnerId }, // the class comes from the extension’s default
        })
        .run();

      const { data } = await this.$integrationApi.post("/clerk/prompt", {
        message: `Generate go lang template (with html) based on this input:\n\n${this.aiGenerateInput.trim()}\n. Return only response, no sub-questions or explanations. You got one try.`,
        config: {
          instructions: [
            `This can contain golang template engine code. Object passed to the go template is ${JSON.stringify(
              this.data
            )}, but can be extended further.`,
            `You can only suggest go template code, not any other programming language.`,
            "Keep the meaning of the original text, do not answer any questions",
            "This can contain golang template engine code, keep it, not translating variables, loops, conditions and other code",
          ],
        },
      });

      const generated = this.removeCodeWrapper(data.processedText.trim());

      let found
      this.editor.state.doc.descendants((node, pos) => {
        if (node.type.name === "spinner" && node.attrs.id === spinnerId) {
          found = { node, pos };
          return false;
        }
        return true;
      });

      const from = found.pos;
      const to = found.pos + 1;

      this.editor
        .chain()
        .focus()
        .deleteRange({ from, to })
        .insertContentAt(from, generated)
        .run();
    },

    async aiFixGrammar() {
      if (!this.$store.getters.isIntegrationActive("protokol-clerk")) return;

      this.$emit("hide");

      const { state, commands } = this.editor;
      const { from, to } = state.selection;

      const selectedText = state.doc.textBetween(from, to, " ");
      const { data } = await this.$integrationApi.post("/clerk/prompt", {
        message: `Fix grammar for this text:\n\n${selectedText}\n`,
        config: {
          instructions: [
            "Fix grammar if needed, keep the original language",
            `Keep the meaning of the original text, do not anwser any questions`,
            "This can contain golang template engine code, keep it",
          ],
        },
      });

      this.editor
        .chain()
        .focus()
        .insertContentAt(
          { from, to },
          this.removeCodeWrapper(data.processedText.trim())
        )
        .run();
    },

    aiTranslate() {
      this.aiTranslateInput = "";
      this.$emit("hide");
      this.$refs.aiTranslateModal.show();
    },
    async aiTranslateConfirm() {
      if (!this.$store.getters.isIntegrationActive("protokol-clerk")) return;
      if (!this.aiTranslateInput.trim()) {
        this.$mainDialog.msgBoxOk(this.$t("fieldsNotValid"));
        return;
      }

      this.$refs.aiTranslateModal.hide();

      const { state, commands } = this.editor;
      const { from, to } = state.selection;

      const selectedText = state.doc.textBetween(from, to, " ");
      const { data } = await this.$integrationApi.post("/clerk/prompt", {
        message: `Translate this text to ${this.aiTranslateInput}:\n\n${selectedText}\n`,
        config: {
          instructions: [
            `Translate to ${this.aiTranslateInput} language, fix grammar if needed`,
            `Keep the meaning of the original text, do not answer any questions`,
            "This can contain golang template engine code, keep it, not translating variables, loops, conditions and other code",
          ],
        },
      });

      this.editor
        .chain()
        .focus()
        .insertContentAt(
          { from, to },
          this.removeCodeWrapper(data.processedText.trim())
        )
        .run();
    },

    addCondition() {
      this.conditionPromptInput = "";
      this.$emit("hide");
      this.$refs.conditionPromptModal.show();
    },
    addConditionConfirm() {
      if (this.conditionPromptInput.trim() !== "") {
        const condition = this.conditionPromptInput.trim();
        const { state, commands } = this.editor;
        const { from, to } = state.selection;
        // const selectedText = state.doc.textBetween(from, to, " ");

        commands.command(({ tr }) => {
          const conditionStart = `{{ if .${condition} }} `;
          const conditionEnd = ` {{ end }}`;
          tr.insertText(conditionStart, from);
          tr.insertText(conditionEnd, to + conditionStart.length);
          return true;
        });

        this.$refs.conditionPromptModal.hide();
      } else {
        this.$mainDialog.msgBoxOk(this.$t("fieldsNotValid"));
      }
    },
    extendCondition(type) {
      this.extendConditionPromptInput = "";
      this.extendConditionType = type;
      this.$emit("hide");
      this.$refs.extendConditionPromptModal.show();
    },
    extendConditionConfirm() {
      const { state, commands, view } = this.editor;
      const { condition, content } = this.contextMenu.conditionSelectionOptions;
      const { tr, selection, doc } = state;
      const { from, to } = selection;

      let newCondition = "";

      if (this.extendConditionType === "disjunction") {
        newCondition = `{{ if and ${condition} .${
          this.extendConditionPromptInput
        } }} ${(content || "").trim()} {{ end }}`;
      } else if (this.extendConditionType === "conjunction") {
        newCondition = `{{ if or ${condition} .${
          this.extendConditionPromptInput
        } }} ${(content || "").trim()} {{ end }}`;
      } else {
        return;
      }

      commands.command(() => {
        tr.insertText(newCondition, from, to);
        view.dispatch(tr);
        return true;
      });
    },

    addLoop() {
      this.loopPromptInput = "";
      this.$emit("hide");
      this.$refs.loopPromptModal.show();
    },
    addLoopConfirm() {
      if (this.loopPromptInput.trim() !== "") {
        const loopVariable = this.loopPromptInput.trim();
        const { state, commands } = this.editor;
        const { from, to } = state.selection;
        // const selectedText = state.doc.textBetween(from, to, " ");

        commands.command(({ tr }) => {
          const loopStart = `{{ range .${loopVariable} }} `;
          const loopEnd = ` {{ end }}`;
          tr.insertText(loopStart, from);
          tr.insertText(loopEnd, to + loopStart.length);
          return true;
        });

        this.$refs.loopPromptModal.hide();
      } else {
        this.$mainDialog.msgBoxOk(this.$t("fieldsNotValid"));
      }
    },

    splitDocument() {
      this.$emit("hide");
      this.$emit("split-document");
    },
    mergeDocument() {
      this.$emit("hide");
      this.$emit("merge-document");
    },
    addDocumentComment() {
      const { empty } = this.editor.state.selection;
      if (empty) return;
      this.$emit('hide');
      this.$emit('add-document-comment');
    },
  },
  computed: {},
};
</script>
